export default function numberInput({ value }) {
  return {
    value: value || 0,

    increment(delta) {
      const newValue = this.value + delta;
      const min = this.$refs.field.getAttribute('min');
      const max = this.$refs.field.getAttribute('max');
      if (typeof min !== 'undefined' && min !== null && newValue < min) {
        window.confirmationModal.tell(`This value cannot be less than ${min}`);
        return;
      }
      if (typeof max !== 'undefined' && max !== null && newValue > max) {
        window.confirmationModal.tell(`This value cannot be greater than ${max}`);
        return;
      }
      this.$refs.field._x_model.set(newValue);
    },
  };
}
